import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const posSearchSchema = z.object({
  fromAppointment: z.string().optional(),
  serviceName: z.string().optional(),
  priceInCents: z.coerce.number().optional(),
  clientId: z.string().optional(),
  clientName: z.string().optional(),
  stylistName: z.string().optional(),
  durationMinutes: z.coerce.number().optional(),
  serviceId: z.string().optional(),
});

export const Route = createFileRoute("/dashboard/$businessSlug/pos")({
  validateSearch: posSearchSchema,
});
